var localStorageHelper = function () {
    this.LOCAL_STORAGE_BUSINESS_STATUS = 'business-status';
    this.LOCAL_STORAGE_ORDER_STATUS = 'business-order-status';

    this.setLocalStorageItem = function (key, value) {
        if (this._isLocalStorageSupported()) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    };

    this.getLocalStorageItem = function (key) {
        if (this._isLocalStorageSupported()) {
            return JSON.parse(localStorage.getItem(key));
        }
    };

    this.removeLocalStorageItem = function  (key) {
        if (this._isLocalStorageSupported()) {
            localStorage.removeItem(key);
        }
    };

    this._isLocalStorageSupported = function () {
        var mod = 'localStorageTest';
        try {
            localStorage.setItem(mod, mod);
            localStorage.removeItem(mod);
            return true;
        } catch (error) {
            return false;
        }
    };
}

var localStorageHelperObject = new localStorageHelper();
